// 语言选项缓存的key
const CACHE_KEY = "local";

// 缓存语言类型
const SET_CACHE_LANGUAGE = (language) => {
    localStorage.setItem(CACHE_KEY, language);
};

// 读取语言类型
const GET_CACHE_LANGUAGE = () => {
    return localStorage.getItem(CACHE_KEY);
};

// 依赖语言的数据缓存 key（内容含语言相关标签，切语言时需清空重建）
const LANGUAGE_DEPENDENT_CACHE_KEYS = ["dictDatas", "brandList"];

// 清空依赖语言的数据缓存
const CLEAR_LANGUAGE_DEPENDENT_CACHE = () => {
    LANGUAGE_DEPENDENT_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
};

// 默认语言选项
export const DEFAULT_LANGUAGE = "zh";

// 可选语言列表
export let languageOption = [
    { label: "中文", value: "zh" },
    { label: "英文", value: "en" },
    { label: "日本语", value: "jp" },
];

/**
 * @desc 获取网站语言
 * @return {string} 语言类型
 */
export const getLanguage = () => {
    const { language } = navigator;
    const lang = language && language.split("-")[0];

    const isValidLanguage = languageOption.some((s) => s.value === lang);
    const browserLanguage = isValidLanguage ? lang : DEFAULT_LANGUAGE;

    // TODO: 已设置vue-i18n默认值和兜底都是zh 所以这里没有缓存zh 可自行按需求缓存
    return GET_CACHE_LANGUAGE() || browserLanguage;
};

/**
 * @param {string} language - 语言类型: en、ch
 * @param {object} vm - 当前vue实例指向
 * @desc 改变网站语言
 * @example
 * ```js
 *  changeLanguage("en",this);
 * ```
 */
export const changeLanguage = (language, vm) => {
    if (!vm) {
        throw "缺少 vm 实例入参";
    }
    vm.$i18n.locale = language;
    SET_CACHE_LANGUAGE(language);
    // 清空依赖语言的本地缓存（字典/品牌标签与语言绑定），刷新后由各页面按新语言重新拉取
    CLEAR_LANGUAGE_DEPENDENT_CACHE();
};

/**
 * @param {string} locale - 当前语言（zh/en/jp）
 * @param {Array} dictDatas - 后端返回的字典数据列表
 * @desc 双语适配：英文环境下将 dictLabel 替换为英文标签 dictLabelEn（未维护时回退中文），
 *       页面原有 dictLabel 渲染逻辑无需改动
 */
export const localizeDictDatas = (locale, dictDatas) => {
    if (locale !== "en" || !Array.isArray(dictDatas)) {
        return dictDatas;
    }
    return dictDatas.map((d) => (d && d.dictLabelEn ? { ...d, dictLabel: d.dictLabelEn } : d));
};

/**
 * @param {string} locale - 当前语言（zh/en/jp）
 * @param {Array} brandTree - 品牌树（节点含 label / labelEn / children）
 * @desc 双语适配：英文环境下优先使用英文品牌名 labelEn（未维护时回退中文 label），
 *       返回新树不改动原数据，页面原有 label 渲染逻辑无需改动
 */
export const localizeBrandTree = (locale, brandTree) => {
    if (locale !== "en" || !Array.isArray(brandTree)) {
        return brandTree;
    }
    return brandTree.map((node) => {
        if (!node) {
            return node;
        }
        return {
            ...node,
            label: node.labelEn || node.label,
            children: Array.isArray(node.children) ? localizeBrandTree(locale, node.children) : node.children
        };
    });
};